export const config = {
  shopsNextPath: '/select-date',
  selectDatePrevPath: '/shops',
  aboutYouPrevPath: '/select-date',
  reviewPrevPath: '/about-you',

  editShopNextPath: 'edit-date',
  editDatePrevPath: 'edit-shop',
};
